import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { CustomIcon } from './custom';
import { LoadedIcon } from 'shared/components/panels/custom-controls/custom-controls-card/components/loaded-icon';
export const ResponsiveIcon = memo(forwardRef((props, ref) => {
    const { large = false, fontSize = large ? '0.9em' : '0.7em', Icon, ...rest } = props;
    if (typeof Icon === 'string') {
        return _jsx(LoadedIcon, { icon: Icon, fontSize: fontSize, ...rest });
    }
    else {
        return _jsx(CustomIcon, { fontSize: fontSize, ref: ref, Icon: Icon, ...rest });
    }
}));
ResponsiveIcon.displayName = 'ResponsiveIcon';
